module.exports = __webpack_public_path__ + "img/icon-kitchen.40fc9f7b.svg";